import Hero from '../components/sections/Hero';
import TrustBar from '../components/sections/TrustBar';
import ServicesGrid from '../components/sections/ServicesGrid';
import ImpactStats from '../components/sections/ImpactStats';
import ProcessTimeline from '../components/sections/ProcessTimeline';
import WhyChooseUs from '../components/sections/WhyChooseUs';
import IndustriesGrid from '../components/sections/IndustriesGrid';
import FaqSection from '../components/sections/FaqSection';
import CtaBanner from '../components/sections/CtaBanner';

export default function Home() {
  return (
    <>
      <Hero />
      <TrustBar />
      <ServicesGrid limit={6} />
      <ImpactStats />
      <ProcessTimeline compact />
      <WhyChooseUs />
      <IndustriesGrid limit={6} />
      <FaqSection limit={6} showFilters={false} />
      <CtaBanner />
    </>
  );
}
